import { memo } from 'react';
import { useTheme } from '@mui/material';
import BrainLeftIllustrationLight from './brainLeft.svg?react';
import BrainLeftIllustrationDark from './brainLeft_dark.svg?react';

export const BrainLeftIllustration = memo(
  (props: React.SVGProps<SVGSVGElement>) => {
    const theme = useTheme();

    if (theme.palette.type === 'dark')
      return <BrainLeftIllustrationDark aria-hidden="true" {...props} />;
    return <BrainLeftIllustrationLight aria-hidden="true" {...props} />;
  },
);
